import icons from "src/assets/icons.png";
import {
  Calendar, Rocket, Building2, Megaphone, ClipboardList, Sparkles,
  Printer, Flag, Image as ImageIcon, Layers, Tv2, MonitorPlay,
  Gift, Boxes, PackageOpen, Leaf, Trophy, Heart,
} from "lucide-react";
import { pickImage } from "./imagePool";

const placeholder = (text, bg = "F1F5F9", fg = "94A3B8") => `data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23${bg}%22%2F%3E%3Ctext%20x%3D%2250%25%22%20y%3D%2250%25%22%20font-family%3D%22sans-serif%22%20font-size%3D%2224%22%20fill%3D%22%23${fg}%22%20text-anchor%3D%22middle%22%20dy%3D%22.3em%22%3E${encodeURIComponent(text)}%3C%2Ftext%3E%3C%2Fsvg%3E`;
const avatar = (name) => `data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22100%22%20height%3D%22100%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23CBD5E1%22%2F%3E%3Ctext%20x%3D%2250%25%22%20y%3D%2250%25%22%20font-family%3D%22sans-serif%22%20font-size%3D%2240%22%20fill%3D%22%2364748B%22%20text-anchor%3D%22middle%22%20dy%3D%22.3em%22%3E${name[0]}%3C%2Ftext%3E%3C%2Fsvg%3E`;

export const COMPANY = {
  name: "Printzee.ae",
  tagline: "Branding. Printing. Events. Gifting.",
  email: "printzone.gcc@gmail.com",
  phone: "0581568787 ",
  address: "707, BMI building, Bank Street, Bur Dubai, Dubai-UAE",
  logo: icons,
};

export const NAV = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Process", href: "#process" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const HERO_STATS = [
  { value: 500, suffix: "+", label: "Projects Delivered" },
  { value: 100, suffix: "+", label: "Corporate Clients" },
  { value: 5, suffix: "+", label: "Years of Craft" },
];

export const SERVICES = [
  {
    id: "events",
    title: "Event Solutions",
    short: "End-to-end planning & execution for corporate experiences.",
    icon: Calendar,
    image: pickImage("events", "Event Solutions", 0),
    items: [
      { icon: Building2, label: "Corporate Events" },
      { icon: Rocket, label: "Product Launches" },
      { icon: Layers, label: "Exhibitions" },
      { icon: Megaphone, label: "Promotional Setups" },
      { icon: ClipboardList, label: "Event Planning" },
      { icon: Sparkles, label: "Event Execution" },
    ],
    blurb:
      "From boardroom briefings to large-format launches, our event team designs immersive corporate experiences that translate your brand into a moment people remember.",
  },
  {
    id: "printing",
    title: "Printing & Large Format Branding",
    short: "Crisp, durable, large-scale visuals that own every wall and window.",
    icon: Printer,
    image: pickImage("printing", "Printing & Large Format Branding", 0),
    items: [
      { icon: Flag, label: "Standees & Flags" },
      { icon: Tv2, label: "Backdrops & Media Walls" },
      { icon: MonitorPlay, label: "Billboards & Signage" },
      { icon: ImageIcon, label: "Banners & Posters" },
      { icon: Layers, label: "Vinyl / Flex Printing" },
      { icon: Boxes, label: "Retail & Exhibition Displays" },
    ],
    blurb:
      "Calibrated colour, premium substrates and engineered finishing — printed in-house and installed across the UAE on schedule, every time.",
  },
  {
    id: "gifting",
    title: "Corporate & Customized Gifting",
    short: "Thoughtful gifts that turn relationships into long-term loyalty.",
    icon: Gift,
    image: pickImage("gifting", "Corporate & Customized Gifting", 0),
    items: [
      { icon: Gift, label: "Corporate Gifts" },
      { icon: PackageOpen, label: "Promotional Merchandise" },
      { icon: Trophy, label: "Event Giveaways" },
      { icon: Boxes, label: "Employee Kits" },
      { icon: Heart, label: "Festive & Premium Gifting" },
      { icon: Leaf, label: "Eco-Friendly Collections" },
    ],
    blurb:
      "Branded giveaways, employee kits and corporate merch — curated and shipped.",
  },
];

export const PORTFOLIO = [
  { id: 1, category: "Branding", title: "Stationery System", img: pickImage("stationery-system", "Stationery System", 0), h: "tall" },
  { id: 2, category: "Printing", title: "Large-Format Banners", img: pickImage("large-format-banners", "Large-Format Banners", 0), h: "short" },
  { id: 3, category: "Events", title: "Corporate Launch", img: pickImage("corporate-launch", "Corporate Launch", 0), h: "mid" },
  { id: 4, category: "Corporate Gifts", title: "Premium Gift Box", img: pickImage("premium-gift-box", "Premium Gift Box", 0), h: "tall" },
  { id: 5, category: "Branding", title: "Identity System", img: pickImage("identity-system", "Identity System", 0), h: "mid" },
  { id: 6, category: "Events", title: "Exhibition Stand", img: pickImage("exhibition-stand", "Exhibition Stand", 0), h: "short" },
  { id: 7, category: "Printing", title: "Premium Press Run", img: pickImage("premium-press-run", "Premium Press Run", 0), h: "mid" },
  { id: 8, category: "Corporate Gifts", title: "Employee Welcome Kit", img: pickImage("employee-welcome-kit", "Employee Welcome Kit", 0), h: "tall" },
  { id: 9, category: "Branding", title: "Outdoor Campaign", img: pickImage("outdoor-campaign", "Outdoor Campaign", 0), h: "short" },
];

export const PORTFOLIO_CATEGORIES = ["All", "Branding", "Printing", "Events", "Corporate Gifts"];

export const WHY_FEATURES = [
  { title: "End-to-End Solutions", desc: "One partner from concept to delivery — no juggling vendors.", value: 12, suffix: "yrs of leadership combined" },
  { title: "Customized Designs", desc: "Every brief is treated as a bespoke design challenge.", value: 100, suffix: "% in-house design team" },
  { title: "Premium Quality Materials", desc: "Calibrated substrates, inks and finishes for lasting results.", value: 40, suffix: "+ premium material options" },
  { title: "Fast Turnaround Time", desc: "Production lines tuned for tight deadlines without compromise.", value: 48, suffix: "hr express delivery" },
  { title: "Reliable Delivery", desc: "On-time installation across all 7 Emirates.", value: 99, suffix: "% on-time rate" },
  { title: "Cost-Effective Pricing", desc: "Transparent quotes with no hidden overheads.", value: 30, suffix: "% avg client savings" },
];

export const PROCESS_STEPS = [
  { step: "01", title: "Consultation", desc: "We listen, understand your brand and define what success looks like." },
  { step: "02", title: "Planning & Design", desc: "Concepts, mockups and a clear production roadmap with timelines." },
  { step: "03", title: "Production", desc: "In-house printing, fabrication and assembly with quality at every stage." },
  { step: "04", title: "Quality Assurance", desc: "Multi-point QA — colour, finish, structure — before anything ships." },
  { step: "05", title: "Delivery & Execution", desc: "On-time logistics, installation and on-site event execution." },
];

export const TESTIMONIALS = [
  {
    name: "Aisha Al Mansouri",
    role: "Marketing Director, Falcon Holdings",
    avatar: avatar("Aisha"),
    quote:
      "Printzee delivered our regional product launch flawlessly — from media walls to gifting suites. Every detail felt deliberate and on-brand.",
  },
  {
    name: "Rohan Kapoor",
    role: "Brand Manager, Meridian Group",
    avatar: avatar("Rohan"),
    quote:
      "Their large-format printing is the cleanest we've used in the UAE. Colours match across every substrate — and they hit every deadline.",
  },
  {
    name: "Sara Hassan",
    role: "HR Lead, Northstar Bank",
    avatar: avatar("Sara"),
    quote:
      "Our employee welcome kits and festive gifting are now something the team looks forward to. Printzee made gifting feel personal at scale.",
  },
];

export const FAQS = [
  {
    q: "What industries do you serve?",
    a: "We work with corporates, agencies, banking, retail, hospitality, healthcare, government and SMEs across the UAE — anyone who values a polished, on-brand presence.",
  },
  {
    q: "Do you provide event management?",
    a: "Yes. From planning and design to on-site execution, we handle corporate events, product launches, exhibitions and promotional setups end-to-end.",
  },
  {
    q: "Can you customize corporate gifts?",
    a: "Absolutely. We source, brand, pack and deliver tailored gifts — from premium hampers to eco-friendly merchandise — with your identity at the centre.",
  },
  {
    q: "Do you handle large-format printing?",
    a: "We specialise in it — billboards, media walls, backdrops, banners, signage, vinyl and flex — printed and installed across all Emirates.",
  },
  {
    q: "What is your turnaround time?",
    a: "Standard projects ship in 3–5 working days. We offer 48-hour express delivery for time-critical requirements; just flag it in your enquiry.",
  },
];

export const SERVICE_OPTIONS = [
  "Event Solutions",
  "Printing & Large Format Branding",
  "Corporate & Customized Gifting",
  "Full Branding Package",
  "Not sure yet — advise me",
];
